import React from 'react';
import { useT } from '../../i18n/useT';
import './CrossPlatformSection.css';

const PLATFORM_ICONS = [
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true"><rect width="32" height="32" rx="8" fill="#0F172A"/><path d="M20.5 16.5c0-2.5 2-3.7 2.1-3.8-1.1-1.6-2.9-1.8-3.5-1.9-1.5-.2-2.9.9-3.6.9-.8 0-1.9-.9-3.2-.9-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.5.8 1.2 1.7 2.5 2.9 2.4 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.2 2.9-2.3.9-1.3 1.3-2.6 1.3-2.7-.1 0-2.2-.8-2.2-3.6z" fill="white"/><path d="M18.5 9c.7-.8 1.1-1.9 1-3-.9.1-2 .6-2.7 1.4-.6.7-1.1 1.8-1 2.9 1.1.1 2.1-.4 2.7-1.3z" fill="white"/></svg>,
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true"><rect width="32" height="32" rx="8" fill="#3DDC84"/><path d="M8 13.5h16v8a2 2 0 01-2 2H10a2 2 0 01-2-2v-8z" fill="white" opacity="0.9"/><path d="M11 11l-2.5-4M21 11l2.5-4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/><circle cx="13" cy="16.5" r="1" fill="#3DDC84"/><circle cx="19" cy="16.5" r="1" fill="#3DDC84"/><rect x="5.5" y="13.5" width="2" height="6" rx="1" fill="white" opacity="0.7"/><rect x="24.5" y="13.5" width="2" height="6" rx="1" fill="white" opacity="0.7"/></svg>,
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true"><rect width="32" height="32" rx="8" fill="#2563EB"/><circle cx="16" cy="16" r="8" stroke="white" strokeWidth="1.5"/><path d="M12 16c0-4 1.8-7 4-7s4 3 4 7-1.8 7-4 7-4-3-4-7z" stroke="white" strokeWidth="1.5"/><path d="M8 16h16M9 12h14M9 20h14" stroke="white" strokeWidth="1" opacity="0.6"/></svg>,
];

export default function CrossPlatformSection() {
  const t = useT();
  const cp = t.crossPlatform;

  const platforms = [
    { name: 'iOS', description: cp.platforms.ios, sub: 'iPhone & iPad' },
    { name: 'Android', description: cp.platforms.android, sub: 'Phone & Tablet' },
    { name: 'Web', description: 'Browser-based access', sub: 'All Desktop Browsers' },
  ];

  return (
    <section className="cross-platform section" aria-labelledby="cross-platform-heading">
      <div className="container">
        <div className="cross-platform__layout">
          <div className="cross-platform__content">
            <div className="badge">{cp.badge}</div>
            <h2 id="cross-platform-heading">
              {cp.headline.split(',')[0]},<br />
              <span className="gradient-text">{cp.headline.split(',')[1]?.trim()}</span>
            </h2>
            <p>{cp.sub}</p>

            <ul className="cross-platform__benefits">
              {cp.benefits.map((benefit, i) => (
                <li key={i} className="cross-platform__benefit">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                    <circle cx="9" cy="9" r="8" fill="#DBEAFE"/>
                    <path d="M6 9l2 2 4-4" stroke="var(--color-primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>

          <div className="cross-platform__platforms">
            {platforms.map((platform, i) => (
              <div key={i} className={`cross-platform__card ${i === 0 ? 'cross-platform__card--featured' : ''}`}>
                <div className="cross-platform__card-icon">{PLATFORM_ICONS[i]}</div>
                <div>
                  <div className="cross-platform__card-name">{platform.name}</div>
                  <div className="cross-platform__card-desc">{platform.description}</div>
                  <div className="cross-platform__card-sub">{platform.sub}</div>
                </div>
              </div>
            ))}
            <div className="cross-platform__sync">
              <div className="cross-platform__sync-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                  <path d="M4 10c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  <path d="M16 10c0 3.3-2.7 6-6 6s-6-2.7-6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  <path d="M17 7l-1-3M17 7l-3-1M3 13l1 3M3 13l3 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <span>{cp.syncLabel}</span>
              <div className="cross-platform__sync-dot" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
